import React, { useState } from 'react';
import { Form, Input, Button, message, Card } from 'antd';
import { LockOutlined, KeyOutlined, CheckOutlined } from '@ant-design/icons';
import axios from 'axios';
import './ChangePassword.css';

const ChangePassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await axios.post('/api/users/change-password/', {
        old_password: values.oldPassword,
        new_password: values.newPassword,
      });
      message.success('密码修改成功');
      form.resetFields();
    } catch (error) {
      message.error('密码修改失败: ' + (error.response?.data?.message || '请稍后重试'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-container">
      <Card className="change-password-card">
        <div className="change-password-header">
          <LockOutlined className="header-icon" />
          <h2>更改密码</h2>
          <p className="header-subtitle">请输入您的当前密码和新密码</p>
        </div>
        
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="change-password-form"
        >
          <Form.Item
            name="oldPassword"
            label="当前密码"
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password 
              prefix={<KeyOutlined className="input-icon" />}
              placeholder="请输入当前密码"
            />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="新密码"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 6, message: '密码长度至少为6位' }
            ]}
            extra="密码必须至少包含6个字符"
          >
            <Input.Password 
              prefix={<LockOutlined className="input-icon" />}
              placeholder="请输入新密码"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="确认新密码"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: '请确认新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password 
              prefix={<CheckOutlined className="input-icon" />}
              placeholder="请再次输入新密码"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading} 
              block
              className="submit-button"
            >
              确认修改
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ChangePassword;
